module.exports = __webpack_public_path__ + "img/tools-time-tracking.c3b57b8e.png";